import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { intlShape } from "react-intl";
import { Loader } from "cxa-components";
import DashboardLayout from "./Layout";
import CharityPopup from "./CharityPopup";
import HealthDeclarationForm from "./widgets/HealthDeclarationForm";
import EnrolmentInfo from "./widgets/EnrolmentInfo";
import MessageBoard from "./widgets/MessageBoard";
import HRAResults from "./widgets/HRAResults";
import RecommendedContent from "./widgets/RecommendedContent";
import InsuranceAdvertisement from "./widgets/InsuranceAdvertisement";
import * as widgetTypes from "./widgets/WidgetTypes";
import Notifications from "components/notifications/notifications";
import DashboardVideos from "./widgets/DashboardVideos";
import HRACallToAction from "./widgets/HRACallToAction";
import ClaimsCard from "./widgets/ClaimsCard";
import NotificationDownloadContainer from "./NotificationDownloadContainer";
import { UnreadMessageNotification } from "components/inAppMessages";
const leftColumnWidgets = ({
  dashboard,
  commonConfig,
  client,
  selectedLanguage,
  getShortLivedToken,
}) => {
  const { byId } = dashboard;
  const { isShopEnabled, isEnrolmentEnabled, isHraEnabled } = commonConfig;

  return (
    <Fragment>
      <HealthDeclarationForm data={byId[widgetTypes.HEALTH_DECLARATION_FORM]} />

      <EnrolmentInfo
        data={byId[widgetTypes.ENROLMENT_INFO]}
        isEnrolmentEnabled={isEnrolmentEnabled}
      />

      {byId[widgetTypes.MESSAGES] && (
        <MessageBoard
          messages={byId[widgetTypes.MESSAGES]}
          getShortLivedToken={getShortLivedToken}
        />
      )}

      <DashboardVideos items={byId[widgetTypes.DASHBOARD_VIDEOS]} />

      <HRACallToAction
        data={byId[widgetTypes.HRARESULTS]}
        isShopEnabled={isShopEnabled}
        isEnrolmentEnabled={isEnrolmentEnabled}
        isHraEnabled={isHraEnabled}
        isForEnrolment={false}
        client={client}
      />

      <HRAResults data={byId[widgetTypes.HRARESULTS]} client={client} />

      <NotificationDownloadContainer notifications={byId[widgetTypes.NOTIFICATIONS]} />

      <RecommendedContent contents={byId[widgetTypes.RECOMMENDED_CONTENT]} />
    </Fragment>
  );
};

leftColumnWidgets.propTypes = {
  dashboard: PropTypes.object,
  commonConfig: PropTypes.object,
  client: PropTypes.string,
  selectedLanguage: PropTypes.object,
  getShortLivedToken: PropTypes.func,
};

const rightColumnWidgets = ({ dashboard, commonConfig, selectedLanguage }) => {
  const { byId } = dashboard;
  const { isShopEnabled, isEnrolmentEnabled, isHraEnabled } = commonConfig;

  return (
    <Fragment>
      <HRACallToAction
        data={byId[widgetTypes.HRARESULTS]}
        isShopEnabled={isShopEnabled}
        isEnrolmentEnabled={isEnrolmentEnabled}
        isHraEnabled={isHraEnabled}
        isForEnrolment={true}
      />

      <InsuranceAdvertisement data={byId[widgetTypes.INSURANCE_ADVERTISEMENT]} />

      <ClaimsCard claimsInfo={byId[widgetTypes.CLAIMS_INFO]} />
    </Fragment>
  );
};

rightColumnWidgets.propTypes = {
  intl: intlShape.isRequired,
  dashboard: PropTypes.object,
  commonConfig: PropTypes.object,
  selectedLanguage: PropTypes.object,
};

const renderNotifications = ({ notifications, removeNotificationsById }) => {
  return <Notifications notifications={notifications} remove={removeNotificationsById} />;
};

renderNotifications.propTypes = {
  notifications: PropTypes.array,
  removeNotificationsById: PropTypes.func,
};

const unreadMessageNotification = ({ commonConfig }) => {
  const {
    messaging: { unreadMessageCount },
  } = commonConfig;

  return unreadMessageCount > 0 ? <UnreadMessageNotification count={unreadMessageCount} /> : null;
};

unreadMessageNotification.propTypes = {
  commonConfig: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.object.isRequired),
    PropTypes.object,
  ]),
};

class Dashboard extends Component {
  static propTypes = {
    selectedLanguage: PropTypes.object,
    dashboard: PropTypes.shape({
      all: PropTypes.array.isRequired,
      byId: PropTypes.object.isRequired,
      pageFieldsById: PropTypes.object.isRequired,
    }),
    commonConfig: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.object.isRequired),
      PropTypes.object,
    ]),
    client: PropTypes.string.isRequired,
    removeNotificationsById: PropTypes.func.isRequired,
    notifications: PropTypes.array.isRequired,
    getShortLivedToken: PropTypes.func.isRequired,
    getDashboardAndInitNotification: PropTypes.func,
    submitCharitySurvey: PropTypes.func,
    initNotificationsWidget: PropTypes.func,
  };

  componentDidMount() {
    const { getDashboardAndInitNotification } = this.props;

    getDashboardAndInitNotification();
  }

  render() {
    const {
      selectedLanguage,
      notifications,
      dashboard,
      commonConfig,
      client,
      removeNotificationsById,
      getShortLivedToken,
      ...rest
    } = this.props;
    const { loading, byId } = dashboard;

    if (loading) {
      return <Loader />;
    }

    return (
      <DashboardLayout
        unreadMessageNotification={unreadMessageNotification({ commonConfig })}
        notifications={renderNotifications({ notifications, removeNotificationsById })}
        charityPopup={
          <CharityPopup
            {...byId[widgetTypes.CHARITY]}
            onSubmit={this.props.submitCharitySurvey}
            {...rest}
          />
        }
        leftColumn={leftColumnWidgets({
          dashboard,
          commonConfig,
          client,
          selectedLanguage,
          getShortLivedToken,
        })}
        rightColumn={rightColumnWidgets({ dashboard, commonConfig, selectedLanguage })}
      />
    );
  }
}

unreadMessageNotification.propTypes = {
  messaging: PropTypes.object.isRequired,
};

export default Dashboard;



// WEBPACK FOOTER //
// ./components/dashboard/Dashboard.js